import { useToast } from '@/components/organisms/feedback/use-toast';
import { useAuthContext } from '@/context/AuthContext';
import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
// import { useToast } from "@/hooks/use-toast";
import { useTranslation } from 'react-i18next';

const DELETE_PROSPECT_CV = gql`
  mutation DeleteProspectCv($uuid: ID!) {
    deleteProspectCv(uuid: $uuid)
  }
`;

export const useDeleteProspectCv = () => {
    const { toast } = useToast();
    const [t] = useTranslation("global");

    const [deleteProspectCvMutation, { loading, error }] = useMutation(DELETE_PROSPECT_CV, {
        onCompleted: () => {
            toast({
                title: t("success.deleted"),
                description: t("success.cvTemplateDeleted"),
                variant: "success",
            });
        },
        onError: (error) => {
            toast({
                title: t("error.deletionFailed"),
                description: error.message,
                variant: "error",
            });
        },
    });

    const deleteProspectCv = async (uuid) => {
        try {
            const result = await deleteProspectCvMutation({
                variables: { uuid },
            });
            return result.data?.deleteProspectCv;
        } catch (err) {
            console.error("Error deleting prospect CV:", err);
            throw err;
        }
    };

    return { deleteProspectCv, loading, error };
};
